import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { baseUrl, localUrl } from "../../config/baseUrl";
import Swal from "sweetalert2";

export default function MessagesList() {
  const [message, setMessage] = useState([]);
  useEffect(() => {
    fetchMessages();
  }, []);


  const fetchMessages = async () => {
    try {
      const response = await axios.get(
        // `${localUrl}/admin/contact/list`, {
        `${baseUrl}/admin/contact/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response?.data?.status) {
        const data = response?.data.data || [];

        setMessage(data);

      }

    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
          // `${localUrl}/admin/contact/delete/${id}`, {
          `${baseUrl}/admin/contact/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        fetchMessages();
        Swal.fire("Deleted!", "Message has been removed.", "success");
      } catch (error) {
        Swal.fire("Error!", "Message to removed animal.", "error");
      }
    }
  };

  return (
    <>
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-6">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                Messgae List
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Contact Messages
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="cards bus-list">
              <div className="bus-filter">
                <div className="row ">
                  <div className="col-lg-6">
                    <h5 class="card-title">Message List</h5>
                  </div>
                </div>
              </div>
              <div className="table table-responsive custom-table">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Message</th>
                      <th>User Name</th>
                      <th>User Mobile</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {message.map((msg, i) => {
                      return (
                        <tr key={msg?.id}>
                          <td>{i + 1}</td>
                          <td>{msg?.message.substring(0, 100)}</td>
                          <td>{msg?.name || "N/A"}</td>
                          <td>{msg?.mobile || "N/A"}</td>
                          <td>
                            <span>{moment(msg?.created_at).format("MMM DD, YYYY")}</span>
                          </td>

                          <td>
                            <div className="action-buttons">
                              <Link
                                title="View"
                                className="action-btn edit-btn"
                                to={`view/${msg.id}`}
                              >
                                <i className="fa fa-eye" />
                              </Link>
                              <button
                                title="Delete"
                                className="action-btn delete-btn"
                                onClick={() => handleDelete(msg.id)}
                              >
                                <i className="fa fa-trash"></i>
                                {/* <span className="tooltip-text">View</span> */}
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
